import { Info } from "lucide-react";
import { Alert, AlertDescription } from "../../../../../components/ui/alert";

interface ContentMatchingNoticeProps {
  fileCount: number;
}

// Shown in place of the folder table, because in this mode there is nothing to
// map and so nothing to render. Without it the dialog says "We found 5 folders
// with 10 files" and then shows nothing about those folders, leaving an
// auditor to guess whether the folders are being used, ignored, or still
// loading.
//
// Stone rather than amber, unlike its unmapped-folders sibling: this is the
// selected mode doing what it says, not a caveat about files that will not
// land where the auditor asked.
export function ContentMatchingNotice({
  fileCount,
}: ContentMatchingNoticeProps) {
  return (
    <Alert className="bg-stone-50 border-stone-200">
      <Info className="h-4 w-4 text-stone-500" />
      <AlertDescription className="text-stone-700">
        {fileCount === 1 ? "The file" : `All ${fileCount} files`} will be
        matched based on file content, ignoring folder names and structure.
      </AlertDescription>
    </Alert>
  );
}
